import { getFirestore, setDoc, doc, Timestamp } from "firebase/firestore";
import { app } from "../config"

const db = getFirestore(app);

// Function to check if the incoming object has all the necessary fields
const hasAllRequiredFields = (object) => {
  // Required Fields
  const requiredFields = [
    "UserID",
    "fullName",
    "businessName",
    "stripeAccountConnected",
    "EOProfileID",
  ];
  for (const field of requiredFields) {
    if (!Object.prototype.hasOwnProperty.call(object, field)) {

      return { success: false, message: `Missing or invalid value for required field: ${field}` };
    }
  }
  return { success: true };
};

// Validation Function
const isPhoneNumberValid = (phoneNumber) => {
  const phoneRegex = /^\d{10}$/; // Expression to match exactly 10 digits
  return phoneRegex.test(phoneNumber);
};

// Define the function to add to EOBusinessProfiles
const createEOBusinessProfileInFirestore = async (EO) => {
  try {
    // Build the EO business profile object, setting the createdAt and updatedAt timestamps
    let EOBusinessProfile = {
      fullName: EO.fullName,
      businessName: EO.businessName,
      organizerName: EO.organizerName,
      contactNumber: EO.contactNumber,
      stripeAccountConnected: EO.stripeAccountConnected,
      approvedTermsOfService: "true",
      userId: EO.UserID,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
      planType: EO.planType || 'free',
      subscriptionStatus: 'free',
    };

    // Add the document to the EOBusinessProfiles collection
    await setDoc(doc(db, "EO_BusinessProfiles", EO.UserID), EOBusinessProfile, { merge: true });
    console.log("Document written with ID: ", EO.UserID);
    return true

  } catch (error) {
    console.error("Error adding document: ", error);
  }
};

const createEOBusinessProfile = async (request) => {
  try {
    const EOData = request;

    // Check if all required fields are present and valid
    const { success, message } = hasAllRequiredFields(EOData);
    if (!success) {
      throw new Error(message);
    }

    // Check if required fields are provided
    if (!EOData) {
      throw new Error("Invalid request data: Missing EO Data");
    }

    // Validate signed terms of service
    if (String(EOData.approvedTermsOfService).toLowerCase() !== "true") {
      throw new Error("Terms of Service must be signed.");
    }

    // Validate the phone number
    const contactNumber = isPhoneNumberValid(EOData.contactNumber) ? EOData.contactNumber : null;

    // Run the function to create EO Business Profile
    await createEOBusinessProfileInFirestore({ ...EOData, contactNumber });

    // Run the function to create EO Business Profile
    await createEOBusinessProfileInFirestore(EOData);
    return { success: true, message: "EO Business Profile Created" };
  } catch (error) {
    console.error("Error processing the request: ", error);
    return { success: false, message: error.message };
  }
};
export { createEOBusinessProfile };